import React from 'react'
import { Button, Container } from '../styles'
import { FaBriefcase } from "react-icons/fa";
import {TagsContainer} from '../styles/components/ServiceText'
import { css } from 'styled-components';



export default function ServiceText({tags, text}) {
    return (
        <Container>
            <p
                css={css`
                    font-size: 1.3rem;

                    @media (max-width: 500px){
                        font-size: 1rem;
                    }
                `}
            >{text}</p>
            <TagsContainer>
                {
                    tags.map(({id, name})=>(
                        
                        <li key={id}><span><FaBriefcase/></span><strong>{name}</strong>  </li>
                    ))
                }
            </TagsContainer>
            <Button to='/contact'  big={true}>Contact us</Button>
        </Container>
    )
}
